import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import veripark from '../assets/images/veripark.svg';
import habib from '../assets/images/HabibBank.png';

function Timeline() {
  return (
    <div id="career">
      <div className="items-container">
        <h1>Professional Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="05/2023 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={veripark} alt="icon" width="40" height="40" />
              <h2 className="vertical-timeline-element-title">VERiPARK</h2>
            </div>
            <h4>Software Engineer</h4>
            <h4 className="vertical-timeline-element-subtitle">Remote</h4>
            <ol>
              <li>Built RESTful APIs for secure data processing in Veripark’s LOS, improving ETL workflow efficiency by 10% using computational graph modelling, DAG-based topological scheduling algorithm.</li>
              <li>Modernized Veriloan by architecting a unified React based frontend using TypeScript and Next.js, leveraging Server-Side Rendering (SSR) to reduce client-side API calls by 40%, thereby improving performance and reducing latency.</li>
              <li>Engineered AI-driven features for stakeholder summarization, analysis, and auditing by integrating AWS SageMaker for fine-tuning and deploying inference models utilizing LLMs from LLaMA using gemma3 to enable advanced NLP.</li>
              <li>Reduced SQL ETL workload by 50% by engineering an internal Python based framework that leveraged AWS Aurora snapshot clones, minimizing production strain, accelerating extraction operations from 19s to 13s.</li>
              <li>Separated ETL workloads on AWS EC2, implemented event-driven loan disbursement using AWS Lambda leveraging long polling on AWS SQS for inter-process transaction exchange, increasing architectural efficiency by 20%.</li>
              <li>Enabled secure connections to a microservices architecture running on Docker by configuring deployments using Kubernetes with Helm, allowing on-the-fly resource management for 25% faster loan document scan cancellation.</li>
              <li>Automated dynamic updates of Azure DevOps YAML pipelines to integrate test cases using Python scripting triggered on successful builds, improving CI/CD pipeline by 20% for streamlining troubleshooting on build failures.</li>
              <li>Coordinated with stakeholders to gather requirements on frequent changes in RBAC policies, credit score updates, and incorporation of new loan disbursement modules into Sprint Backlogs within Agile Scrum throughout SDLC.</li>
            </ol>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="08/2022 - 05/2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={habib} alt="icon" width="40" height="40" />
              <h2 className="vertical-timeline-element-title">Habib Bank AG Zurich</h2>
            </div>
            <h4>Software Engineer</h4>
            <ol>
              <li>Developed REST and GraphQL APIs to power internal auditing dashboards, utilizing an alerting mechanism to detect anomalies on every database request, ensuring ISO compliant data processing</li>
              <li>Enhanced mobile-first Single-SPA React platform using JavaScript by integrating Redis real-time queue management and Cache-Aside strategy to ensure accurate, invalidation data delivery, reducing fetch bandwidth from 60s to 20s.</li>
              <li>Developed robust SQL migration in Go, adding new billing fields and enforcing foreign key integrity with seamless schema updates, validated impact to ensure zero downtime and data consistency for tenants.</li>
              <li>Integrated try-catch logging into an internal packaging module and automated log uploads to an existing FastAPI FTP server, for system auditing from local to server and streamlining error diagnostics across teams.</li>
              <li>Participated in Agile sprints, incorporating continuous feedback from financing SMEs and contributing to retrospectives with the cross-functional team to uphold quality standards in auditing modules.</li>
            </ol>
          </VerticalTimelineElement>

        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;